import * as React from "react";

import { Input } from "./input";

export function DurationInput({ value, onChange, placeholder = "00:00:00" }: { value: string; onChange: (seconds: number | null) => void; placeholder?: string }) {
    const [display, setDisplay] = React.useState(value);

    React.useEffect(() => {
        setDisplay(value);
    }, [value]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
        if (allowed.includes(e.key)) return;
        if (!/^\d$/.test(e.key)) e.preventDefault();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
        let formatted = digits;
        if (digits.length > 4) {
            formatted = `${digits.slice(0, 2)}:${digits.slice(2, 4)}:${digits.slice(4, 6)}`;
        } else if (digits.length > 2) {
            formatted = `${digits.slice(0, 2)}:${digits.slice(2)}`;
        }
        setDisplay(formatted);
        if (digits.length === 6) {
            onChange(Number(digits.slice(0, 2)) * 3600 + Number(digits.slice(2, 4)) * 60 + Number(digits.slice(4, 6)));
        } else {
            onChange(null);
        }
    };

    return <Input value={display} onChange={handleChange} onKeyDown={handleKeyDown} placeholder={placeholder} inputMode="numeric" />;
}
